export class UserModel {
    public Id: string;
    public Username: string;
    public Agenzia: string;
    public Nome: string;
    public Tel: string;
    public Cell: string;
    public Email: string;
}


// WEBPACK FOOTER //
// ./src/models/user.model.ts